// extracted by mini-css-extract-plugin
export var buttonContainer = "_5y-1";
export var fontSizeSelect = "_5y-3";
export var formatSelect = "_5y-2";
export var formats = "_5y-4";
export var hidden = "_5y-5";
export var icon = "_5y-6";
export var select = "_5y-0";